export const APPEARANCE_KEY = 'lunadesk.appearance.mode.v1';
export const JOY_MODE_KEY = 'lunadesk.appearance.joy.v1';
export const MODES = ['light', 'dark', 'auto'];

export function colorSchemeFor(preference, date = new Date()) {
  if (preference === 'light' || preference === 'dark') return preference;
  const hour = date.getHours();
  return hour >= 20 || hour < 7 ? 'dark' : 'light';
}

export function nextAppearanceBoundary(date = new Date()) {
  const next = new Date(date);
  if (date.getHours() < 7) next.setHours(7, 0, 0, 0);
  else if (date.getHours() < 20) next.setHours(20, 0, 0, 0);
  else { next.setDate(next.getDate() + 1); next.setHours(7, 0, 0, 0); }
  return next;
}

export function readAppearance() {
  try {
    const stored = window.localStorage.getItem(APPEARANCE_KEY);
    return MODES.includes(stored) ? stored : 'auto';
  } catch { return 'auto'; }
}

export function applyAppearance(preference) {
  const colorScheme = colorSchemeFor(preference);
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-joy-color-scheme', colorScheme);
    document.documentElement.setAttribute('data-appearance-mode', preference);
    document.documentElement.style.colorScheme = colorScheme;
  }
  return colorScheme;
}

// Runs before React mounts, so a saved dark theme does not first render light.
export const INITIAL_APPEARANCE = (() => {
  const preference = readAppearance(), colorScheme = applyAppearance(preference);
  try { window.localStorage.setItem(JOY_MODE_KEY, colorScheme); } catch { /* Optional storage. */ }
  return { preference, colorScheme };
})();
